
import request from '@/request'
const part_url = 'news/web/advertisement/';


/**
 * 查询咨询
 *
 * @param {*} categoryId 分类id
 * @param {*} pageNow 当前页
 * @param {*} pageSize 页容
 * @param {*} title 标题
 * @returns
 */
function list(data) {
  let url = part_url + "list";
  return request.get(url, data)
}




export default {
    list,
}



// WEBPACK FOOTER //
// ./src/api/advertisement.js